module.exports = "<a app-ui-production__icon\r\n    ng-href=\"{{$ctrl.href}}\"></a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/components/production/template.html
// module id = 170
// module chunks = 0